<template>
  <div>
    <template v-if="courseStatus === -1">
<!--      <span>已结束</span>-->
    </template>
    <template v-else-if="courseStatus === 2">
<!--      <span>未开始</span>-->
    </template>
    <template v-else-if="courseStatus === 1">
<!--      <div>-->
<!--        <span>距离开课</span>-->
<!--        <span>剩余&nbsp;{{ timecountdown | formatSencond2MinuteSencond }}</span>-->
<!--      </div>-->
    </template>
    <template v-else-if="courseStatus === 0">
      <div class="learning_join" @click.stop="enterRoom(data)">进入课堂</div>
    </template>
    <template v-else-if="courseStatus === 3">
<!--      <span>已过进入时间</span>-->
    </template>
  </div>
</template>

<script>
import { enterStatus } from '@/utils/format-tools'

export default {
  name: "course_join",
  components: {},
  data() {
    return {
        timer: '',
        timecountdown: this.data.timecountdown
    };
  },
  props: ["data"],
  computed: {
    courseStatus: function() {
      const {s_time, e_time } = this.data;
      const { pre_in_class, after_in_class } = this.data.config || {pre_in_class: 0, after_in_class: 0};
      return enterStatus({
        timecountdown: this.timecountdown,
        pre_in_class,
        after_in_class,
        s_time,
        e_time
      })
    }
  },
  watch: {},
  methods: {
    enterRoom (data) {
      this.$emit('enterRoom', data)
    },
    enterInterval (data) {
      this.timecountdown --
      if (this.timecountdown < 0) {
        clearInterval(this.timer)
      }
    }
  },
  created() {},
  mounted() {
    this.timer = setInterval(this.enterInterval, 1000)
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    clearInterval(this.timer)
  },
  destroyed() {},
  activated() {}
};
</script>
<style lang="less" scoped>
.learning_join{
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  height: 80px;
  width: 80px;
  background-color: #32BE88;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #fff;
  font-size: 1.2rem;
  cursor:pointer;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
